import { ObjectKeysBaseValueConverter } from 'General/Resources/ValueConverters/ObjectKeysBase';
export class ObjectKeysValueConverter extends ObjectKeysBaseValueConverter {

}